import { render, staticRenderFns } from "./Candidatos.vue?vue&type=template&id=da1d4bd8&scoped=true&"
import script from "./Candidatos.vue?vue&type=script&lang=js&"
export * from "./Candidatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d4bd8",
  null
  
)

export default component.exports